'use client'
import { useEffect, useRef } from 'react'

import type VConsole from 'vconsole'

export const VConsoleComponent = ({ isVConsoleEnabled, initCallback }: { isVConsoleEnabled: boolean, initCallback?: () => void }) => {
  const instance = useRef<VConsole | null>(null)

  useEffect(() => {
    if (isVConsoleEnabled) {
      void import('vconsole')
        .then(({ default: VConsole }) => {
          const vconsoleInstance = new VConsole({ theme: 'dark' })
          instance.current = vconsoleInstance
          initCallback?.()
        })
        .catch((error) => {
          console.error('[system] VConsole init failed', error)
        })
    }

    return () => {
      instance.current?.destroy()
    }
  }, [isVConsoleEnabled, initCallback])

  return null
}

